<template>
  <div v-if="state.show" class="modal">
    <div class="banner">
      <button
        class="iconGuanbi absolute text-white-080"
        @click="state.show = false"
      >
        <i class="iconfont icon-guanbi" />
      </button>
      <a href="https://lu.ma/rubazci1" target="_blank">
        <img
          class="bannerImage"
          :src="require('@/assets/images/mintBadgeBanner.jpeg')"
        />
      </a>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
const state = reactive({
  show: true,
});
</script>

<style lang="scss" scoped>
@media screen and (max-width: 800px) {
  .banner {
    width: 80% !important;
    transform: translate(-155px, -150px) !important;
    z-index: 999;
  }
}
.modal {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
}
.banner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-250px, -150px);
  width: 588px;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0px 0px 16px 0px rgba(255, 255, 255, 0.5);
}
.bannerImage {
  width: 100%;
}
.iconGuanbi {
  right: 18px;
  top: 28px;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.2);
}
</style>
